var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesOrderReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.354 239.041V29.572h-51.8V0H86.142v180.935H26.875V512h458.249V239.041h-47.77zM407.129 59.798v179.244h-21.574V59.798h21.574zM116.368 30.226h238.96v208.816H225.313l-48.419-58.107h-60.526V30.226zm338.531 451.548H57.101V211.161h105.635l48.419 58.107h243.743v212.506z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.328 80.183h139.04v30.226h-139.04zM166.328 140.638h139.04v30.226h-139.04zM332.572 372.14h91.248v30.226h-91.248zM332.572 422.311h91.248v30.226h-91.248z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOrderReport);
export default __webpack_public_path__ + "static/media/sales-order-report.9f5c176cfc3026d2be0d794c294dd7b2.svg";
export { ForwardRef as ReactComponent };